// September 2026 monthly report companion blog.
import { defineDocument, em, image, link, p, section, text, } from '../../schema';
export const blogPartyGameStreamingByTheNumbersSeptember2026Document = defineDocument({
    id: 'blog:party-game-streaming-by-the-numbers-september-2026',
    kind: 'blog',
    slug: 'party-game-streaming-by-the-numbers-september-2026',
    route: '/blog/party-game-streaming-by-the-numbers-september-2026',
    seo: {
        title: 'Party Game Streaming by the Numbers: September 2026',
        description: 'Mario Kart World finds another gear, Mimic Party makes some noise, and Jhay powers up the streamer rankings in our September 2026 Twitch party game report.',
        imageAsset: 'twitchStats202609',
    },
    hero: {
        eyebrow: [text('Airhead Blog')],
        title: [text('Party Game Streaming by the Numbers: September 2026')],
        description: [
            text('Mario Kart World finds another gear, Mimic Party makes some noise, and Jhay powers up the streamer rankings in our September 2026 Twitch party game report.'),
        ],
        imageAsset: 'twitchStats202609',
        imageAlt: 'September 2026 party-game streaming report graphic',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-10-04T00:00:00.000Z'),
        updatedAt: new Date('2026-10-04T00:00:00.000Z'),
        tags: ['party-central'],
    },
    sections: [
        section({
            id: 'article',
            blocks: [
                p([
                    text('September brought 69,818 streamers to the party games we track on Twitch, 17% fewer than in August. '),
                    em('MECCHA CHAMELEON'),
                    text(' and '),
                    em('The Choicer Voicer'),
                    text(' accounted for about 65% of the fall in observed streams as their summer rush faded.'),
                ]),
            ],
            sections: [
                section({
                    id: 'article__mario-kart-finds-another-gear',
                    title: 'Mario Kart Finds Another Gear',
                    blocks: [
                        p([
                            em('Mario Kart World'),
                            text(' climbed from 12th to second in Party Score, with 20% more streamers playing than in August. Nintendo’s '),
                            link('https://www.nintendo.com/en-gb/Support/Nintendo-Switch-2/Game-Updates/How-to-Update-Mario-Kart-World-2842542.html', 'September update'),
                            text(' added 10 classic '),
                            em('Super Mario Kart'),
                            text(' courses, two Knockout Tour routes, and Spectator Mode. Streaming increased around the update’s September 9–10 rollout.'),
                        ]),
                        p([
                            text('Typically, as more streamers pile into a game, the average audience shrinks. However, three channels helped lift the game’s average from 18 viewers in August to 53 in September: '),
                            link('https://twitch.tv/indegnasen0706', '布団ちゃんと申します'),
                            text(', '),
                            link('https://twitch.tv/hanjoudesu', 'はんじょう'),
                            text(', and '),
                            link('https://twitch.tv/kato_junichi0817', '加藤純一うん〇ちゃん'),
                            text(' drew huge crowds, and their streams accounted for 57% of the game’s viewership this month.'),
                        ]),
                        p([
                            text('Despite the tough competition, '),
                            em('nanos world'),
                            text(' kept its grip on the top Party Score as French creators continued their ninja roleplay stories on Zenkai. '),
                            link('https://twitch.tv/mehditdonc', 'MehDitDonc'),
                            text(' and '),
                            link('https://twitch.tv/tayoh_', 'Tayoh_'),
                            text(' were among the returning cast. MehDitDonc’s Ryūji Uchiha storyline reached Episode 43 by the end of the month. More than half of the game’s August streamers came back in September, and no single channel made up more than 4% of its streams.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__jhays-nintendo-marathon',
                    title: 'Jhay’s Nintendo Marathon',
                    blocks: [
                        p([
                            link('https://twitch.tv/jhay', 'Jhay'),
                            text(' went straight to first in Streamer Party Score after five months outside the rankings. Their September subathon spanned 13 games, mostly Nintendo titles, including '),
                            em('Wii Sports Resort'),
                            text(', '),
                            em('Mario Kart Wii'),
                            text(', and '),
                            em('Mario Party DS'),
                            text('. Every game averaged more than 200 viewers. That mix of activity, audience, and variety put Jhay at the top with a score of 99.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__mimic-party-makes-some-noise',
                    title: 'Mimic Party Makes Some Noise',
                    blocks: [
                        p([
                            link('https://store.steampowered.com/app/5053820/Mimic_Party/', 'Mimic Party'),
                            text(' launched on August 27 and reached 2,576 streamers in its first full month, sixth among all the games we follow. The game asks players to imitate sounds, with custom sound packs giving groups room for familiar noises and their own jokes.'),
                        ]),
                        p([
                            text('Its appeal was global, with 89% of its streams in languages other than English. Spanish, German, and Polish creators led the way. Streamers bringing large audiences to the game included '),
                            link('https://twitch.tv/auronplay', 'auronplay'),
                            text(', '),
                            link('https://twitch.tv/elmariana', 'ElMariana'),
                            text(', '),
                            link('https://twitch.tv/gotaga', 'Gotaga'),
                            text(', and '),
                            link('https://twitch.tv/xrohat', 'xRohat'),
                            text('.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__shady-job-builds-up-beetleball-rolls-in',
                    title: 'Shady Job Builds Up, Beetleball Rolls In',
                    blocks: [
                        p([
                            link('https://store.steampowered.com/app/4190710/Shady_job/', 'Shady Job'),
                            text(' from GAZE IN GAMES puts a crew of construction workers on a dubious assignment: carry a body bag up a skyscraper and bury it in concrete. The occupant is still alive and fights back, breaking structures and pushing workers off ledges. Players build bridges and operate cranes to get the bag to the top.'),
                        ]),
                        image({
                            imageAsset: 'blogStats202609ShadyJob',
                            imageAlt: 'Gameplay screenshot from Shady Job, a cooperative construction game',
                            caption: 'Shady Job gameplay: the mafia wants to get rid of a body.',
                        }),
                        p([
                            text('The September 10 release reached 163 streamers, the most among September’s new arrivals. It found audiences among English and Russian creators, and '),
                            link('https://twitch.tv/trymacs', 'Trymacs'),
                            text(' showed it to a big German crowd.'),
                        ]),
                        p([
                            link('https://store.steampowered.com/app/2776270/Beetleball/', 'Beetleball'),
                            text(' from Bugfight Studio turns dung-beetle soccer into matches for up to 12 players, with multiple balls in play and beetle classes that can teleport or build mushroom launchpads. It launched on September 3 and reached 64 channels, averaging 684 viewers. Among the creators taking the field were '),
                            link('https://twitch.tv/tumblurr', 'Tumblurr'),
                            text(' and '),
                            link('https://twitch.tv/joe_bartolozzi', 'Joe_Bartolozzi'),
                            text('.'),
                        ]),
                    ],
                }),
                section({
                    id: 'article__read-the-full-report',
                    title: 'Read the Full Report',
                    blocks: [
                        p([
                            text('The '),
                            link('/party-central/reports/2026-09-top-party-games-and-streamers', 'full September 2026 report'),
                            text(' has complete rankings, language breakdowns, game deep dives, and streaming patterns by day and hour, along with our methodology.'),
                        ]),
                    ],
                }),
            ],
        }),
    ],
});
//# sourceMappingURL=party-game-streaming-by-the-numbers-september-2026.js.map